import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Job } from "../entites/job";
import { Observable, catchError, throwError } from "rxjs";

@Injectable({ providedIn: 'root' })
export class JobService {

  private obtenirUrl = environment.apiBaseUrl + 'job';

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router
  ) { }

  public ObtenirJobs(): Observable<Job[]> {
    return this.http.get<Job[]>(this.obtenirUrl, this.httpOptions);
  }

  public ForcerJob(jobId: string): Observable<Job> {
    return this.http.post<Job>(`${this.obtenirUrl}/${jobId}/force`, this.httpOptions);
  }

  public ModifierJob(job: Job): Observable<Job> {
    return this.http.put<Job>(this.obtenirUrl, job, this.httpOptions);
  }
}
